import { callApi } from "./fetchTools";
import {
  HTTP_METHOD_GET,
  HTTP_METHOD_POST,
  HTTP_METHOD_PUT,
} from "../utils/constant";
import apis from "../common/apis";
import { IResponsePaging } from "../models/base";
import { IOrder } from "../models/orderModel";
import { IOrderDetail } from "../models/orderDetailModel";
import { IPromotionModel } from "../models/IPromotionModel";
import IPromotionVoucherCodeModel from "../models/IPromotionVocherCodeModel";
import IReferralCodeModel from "../models/IReferralCodeModel";
import SubmitOrderModel from "../models/submitOrderModel";
import { ACCESS_TOKEN, USER_INFO } from "../common/constant";
import { getVoucherCode } from "../utils/helpers";

const submitOrder = (model: SubmitOrderModel) => {
  const user = localStorage.getItem(USER_INFO);
  const accessToken = localStorage.getItem(ACCESS_TOKEN);
  const voucherCode = getVoucherCode();

  const payload = { ...model, order_voucher_code: voucherCode };

  if (user && accessToken) {
    return callApi<any>(HTTP_METHOD_POST, apis.order_submit_v3, payload);
  }

  return callApi<any>(
    HTTP_METHOD_POST,
    apis.order_submit_anonymous_v3,
    payload
  );
};

export default {
  submitOrder: submitOrder,
  getOrders: (query: any) => {
    return callApi<IResponsePaging<IOrder[]>>(
      HTTP_METHOD_GET,
      apis.order_list,
      query
    );
  },
  getOrder: (id: any) => {
    return callApi<IResponsePaging<IOrderDetail>>(
      HTTP_METHOD_GET,
      `${apis.order_detail}${id}`,
      {}
    );
  },
  rejectOrder: (info: any) => {
    return callApi<IResponsePaging<IOrderDetail>>(
      HTTP_METHOD_PUT,
      `${apis.order_reject}${info.id}`,
      { reason: info.reason }
    );
  },
  changePaymentMethod: (info: any) => {
    return callApi<any>(
      HTTP_METHOD_POST,
      apis.order_change_payment_method,
      info
    );
  },
  getOrderPromotion: (info: any) => {
    const voucherCode = info.order_voucher_code || getVoucherCode();
    const payload = {
      ...info,
      order_voucher_code: voucherCode,
    };

    return callApi<IPromotionModel[]>(
      HTTP_METHOD_POST,
      apis.order_promotion,
      payload
    );
  },
  checkVoucherCode: (code: any) => {
    return callApi<IPromotionVoucherCodeModel>(
      HTTP_METHOD_GET,
      `${apis.public_check_discount_code}${code}`,
      null
    );
  },
  checkReferralCode: (code: any) => {
    return callApi<IReferralCodeModel>(
      HTTP_METHOD_GET,
      `${apis.public_check_present_code}${code}`,
      null
    );
  },
  getIdOrderByCode: (code: string) => {
    return callApi<IReferralCodeModel>(
      HTTP_METHOD_GET,
      `${apis.public_check_present_code}${code}`,
      null
    );
  },
};
